import * as React from 'react';
import { useCarousel } from './carousel';
import { cn } from '../../utils/cn';
import { useABTestIsOn } from '../../../../web/app/modules/root/hook/use-growthbook';

export const CarouselPagination = () => {
    const { currentSlide, totalSlides } = useCarousel();
    const isTileMediaSlider = useABTestIsOn('tile-media-slider');
    const maxDots = 5;
    const dotSize = 8; // px
    const gapSize = 4; // px
    const fullDotWidth = dotSize + gapSize;

    const visibleDots = Math.min(maxDots, totalSlides);
    const halfVisibleDots = Math.floor(visibleDots / 2);

    // Calculate start dot properly
    let startDot = 0;
    if (currentSlide <= halfVisibleDots) {
        startDot = 0;
    } else if (currentSlide >= totalSlides - halfVisibleDots - 1) {
        startDot = totalSlides - visibleDots;
    } else {
        startDot = currentSlide - halfVisibleDots;
    }

    const translateX = startDot * fullDotWidth;

    if (isTileMediaSlider) {
        // AB Test variant A
        return (
            <div
                className="rocco-carousel-pagination z-10 flex items-center justify-start overflow-hidden"
                style={{
                    width: `${dotSize * visibleDots + gapSize * (visibleDots - 1)}px`,
                }}
            >
                <div
                    className="flex shrink-0 transition-transform duration-500 ease-in-out"
                    style={{ transform: `translateX(-${translateX}px)` }}
                >
                    {[...Array(totalSlides).keys()].map((key, index) => (
                        <div
                            key={key}
                            className={`rounded-full transition-all duration-300 ease-in-out ${currentSlide === key ? 'bg-white opacity-100' : 'bg-white opacity-40'}`}
                            style={{
                                width: `${dotSize}px`,
                                height: `${dotSize}px`,
                                marginRight:
                                    index === totalSlides - 1
                                        ? 0
                                        : `${gapSize}px`,
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            // AB Test variant B
            <div className="rocco-carousel-pagination z-10 flex items-center justify-center gap-1">
                {[...Array(totalSlides).keys()].map((key) => (
                    <div
                        key={key}
                        className={cn(
                            'size-2 rounded-full bg-white opacity-40',
                            currentSlide === key && 'opacity-100'
                        )}
                    />
                ))}
            </div>
        );
    }
};
